/* BRÁNA obrazovek týmu (/manazer, /crm/team, /crm/ik, /crm/vyhlaseni).
 * Pustí, když uživatel tým MÁ (lib/mujTym.maTym: role, tym_clenu > 0, nebo
 * se starším backendem přijatá odchozí pozvánka). Jinak tiše na „/“, stejně
 * jako dřív ProtectedRoute roles. Je to jen UX — data hlídá backend přes
 * potvrzené vztahy. Přihlášení řeší vnější ProtectedRoute. */
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { LoadingGate } from "@/components/AppErrorBoundary";
import { maPrijatouPozvanku, nastavNahraduTymu, potrebujeNahradu, useMaTym } from "@/lib/mujTym";
import { textTymu } from "./mujTymTexty";
import { nactiOdchozi } from "./pozvankaApi";

/* Náhrada pro starší backend (bez tym_clenu): přijatá odchozí pozvánka = tým.
   Chyba sítě / chybějící routa = žádná náhrada (fail-closed). */
async function overNahraduTymu(user) {
  if (!potrebujeNahradu(user)) return;
  try {
    const res = await nactiOdchozi();
    if (maPrijatouPozvanku(res && res.data)) nastavNahraduTymu(user.id || user._id);
  } catch {
    /* nic — brána pošle na „/“ */
  }
}

export default function TymBrana({ children }) {
  const { user } = useAuth();
  const { lang } = useLanguage();
  const ma = useMaTym(user);
  const [overeno, setOvereno] = useState(() => !potrebujeNahradu(user));

  useEffect(() => {
    if (ma || overeno) return undefined;
    let zruseno = false;
    overNahraduTymu(user).finally(() => { if (!zruseno) setOvereno(true); });
    return () => { zruseno = true; };
  }, [ma, overeno, user]);

  if (ma) return children;
  if (!overeno) return <LoadingGate message={textTymu(lang, "overuji")} />;
  return <Navigate to="/" replace />;
}
